import React from "react";
import { FiPlus, FiTrash } from "react-icons/fi";
import SearchBar from './SearchBar'

const RecommendationWrapper = ({ title, onAdd, searchTerm, setSearchTerm, placeholder, children }) => {
  return (
    <div className="p-6 max-w-4xl w-full mx-auto">
      <div className="flex justify-between">
      <h1 className="text-2xl font-bold mb-6">{title}</h1>

        <div className="flex space-x-2 justify-end mb-4">
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder={placeholder}
            style="px-4 w-full"
          />


          <button
            onClick={onAdd}
            className="flex items-center justify-center bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-800 transition duration-300 w-40"
            aria-label="Add new item"
          >
            <FiPlus className="mr-2" />
            <span className="flex-1 text-center">Add</span>
          </button>
        </div>
       </div>
      {/* Page Content */}
      {children}  

      <div style={{ height: "15px", width:"720px"}} />
      </div>
     

  );
};

export default RecommendationWrapper;